import { render, staticRenderFns } from "./MStoreCardPanel.vue?vue&type=template&id=39195609&scoped=true&"
import script from "./MStoreCardPanel.vue?vue&type=script&lang=ts&"
export * from "./MStoreCardPanel.vue?vue&type=script&lang=ts&"
import style0 from "./MStoreCardPanel.vue?vue&type=style&index=0&id=39195609&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39195609",
  null
  
)

export default component.exports